import { useCallback } from 'react';
import { BM_PERIODS } from '../../constants/enrollment';
import { useAppContext } from '../contexts/AppContext';
import {
    isCurrentDateWithinBMPeriod,
    isCurrentDateBeforeBOYPeriod,
} from '../utils/assessmentWindowsUtils';

export const isPeriodAfter = (currentPeriod, period, bmPeriods) =>
    bmPeriods.indexOf(currentPeriod) < bmPeriods.indexOf(period);

const useAssessIcons = (bmPeriods = BM_PERIODS) => {
    const { bmWindowConfig, isDemoClassSelected, bmWindow } = useAppContext();

    const isStrictConfig = bmWindowConfig === 'strict';

    // for demo class icons are visible for all periods
    // for teacher class icons are visible for current period and before
    // in strict bm windows mode icons are visible only after BOY starts
    const isBMAssessmentIconVisible = useCallback(
        assessmentPeriod => {
            if (isDemoClassSelected) {
                return true;
            }

            if (isPeriodAfter(bmWindow.period, assessmentPeriod, bmPeriods)) {
                return false;
            }
            if (isStrictConfig) {
                return !isCurrentDateBeforeBOYPeriod(bmWindow);
            }
            return true;
        },
        [bmWindow, isDemoClassSelected, isStrictConfig],
    );

    // in strict bm windows mode icons are enabled only within BM period
    // but this does not apply to demo classes
    const isBMAssessmentIconEnabled = useCallback(
        period => {
            if (isDemoClassSelected || !isStrictConfig) {
                return true;
            }
            return isCurrentDateWithinBMPeriod(bmWindow, period);
        },
        [bmWindow, isDemoClassSelected, isStrictConfig],
    );

    return {
        isBMAssessmentIconVisible,
        isBMAssessmentIconEnabled,
    };
};

export default useAssessIcons;
